import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router'
import { Redirect } from 'react-router-dom'


class App extends React.Component {
    render() {
      const {
        authenticated,
        component: Component,
        ...props
      } = this.props
  
      return (
        <Route
          {...props}
          render={props =>
            authenticated
              ? <Component {...props} />
              : (
              <Redirect to={{
                pathname: '/sign',
                state: { from: props.location }
              }} />
            )
          }
        />
      )
    }
  }

//=====================================
//  CONNECT
//-------------------------------------
const mapStateToProps = (state) => {
    return {
        authenticated: state.auth.user.authenticated
    }
}
export default connect(mapStateToProps)(App);


// WEBPACK FOOTER //
// ./src/pages/app.js